module.exports = __webpack_public_path__ + "img/chat_off.be7e9cdc.svg";